import React,{useState} from 'react';
import {
  AppstoreOutlined,MailOutlined,BankOutlined,MobileOutlined,
  CreditCardOutlined,FileOutlined,CreditCardTwoTone,DatabaseOutlined,ApiOutlined,
  InteractionOutlined,ContainerOutlined,
  UserOutlined,PhoneOutlined,} from '@ant-design/icons';
import { Layout, Menu,Input, Divider,Modal, 
  Card, Row, Col, Space, Button, Avatar, Form,message, Spin,Alert, notification } from 'antd';
import axios from "axios"; 
import { useSelector } from "react-redux";
import { useGetApiRoutesQuery } from '../../services/ApiRoutes';
import { Link,useNavigate } from "react-router-dom";
import SiderBar from './SiderBar';
import SendOPT from './SendOPT';
import cartimg from '../../assets/images/cart.png'
import cards from '../../assets/images/cards.png'
import SweetAlert from 'react-bootstrap-sweetalert'
/*import Particles from "react-tsparticles";
import { loadFull } from "tsparticles";*/

const { Header, Content, Footer } = Layout;
const { SubMenu } = Menu;


const Profile = () => {

 const [ActiveKey, setActiveKey] = useState(1);
 const [isModalVisible, setIsModalVisible] = useState(false);
 const [isModal2Visible, setIsModal2Visible] = useState(false);
 const [cardPayment, setIscardPayment] = useState(false);
 const [CardPayLoading, setCardPayLoading] = useState(false);
 const [optLoading, setOptLoading] = useState(false);
 const [cpayPaymentLoading, setCpayPaymentLoading] = useState(false);
 const [OTMAmount, setOTMAmount] = useState(0);
 const [OTPCusNumber, setOTPCusNumber] = useState(0);
 const [ExtId, setExtId] = useState(0);
 const [isOTPModalVisible, setIsOTPModalVisible] = useState(false);
 const { user: currentUser } = useSelector((state) => state.auth);
 const formRef = React.createRef();
 const clientCode = currentUser.ClientCode;
 const clientAPIkey = currentUser.ClientApikey;

 const [open, setOpen] = useState(false);
 const [notificationApi, contextHolder] = notification.useNotification();

 const navigate = useNavigate();

if (!currentUser) {
  navigate('/')
  }

  const openNotificationWithIcon = (notificationType, title, content) => {
    notificationApi.error({
      message: title,
      description: content,
      duration: 0,
      placement:'bottomLeft'
    });
  };

const showModal2 = () => {
    setIsModal2Visible(true);
    };
const showModal = () => {
    setIsModalVisible(true);
    };
const handleOk = () => {
      setIsModalVisible(false);
      setIsModal2Visible(false);
      setIsOTPModalVisible(false);
      setIscardPayment(false);
    };

const handleCancel = () => {
       setOptLoading(false)
      setIsModalVisible(false);
      setIsModal2Visible(false);
      setIsOTPModalVisible(false);
      setIscardPayment(false);
    };
    // running the card example
const cardPaymentExample = (values) =>{
      setCardPayLoading(true)
      handleCancel();
      
      var extId = "0x" + (new Date().getTime());
      var customerNumber = values.customer;
      var amountDue = values.amount;
      var customeremail = values.email;
      // first request
      var data = {
          "transactionRequest": {
              "extTransactionId": extId,
              "clientCode": clientCode,
              "msisdn": customerNumber,
              "otp": "",
              "amount": amountDue,
              "checksum": "",
              "currency": "maloti",
              "otpMedium": "sms",
              "redirectUrl": "",
         }
      };
      let headersList = {
        "accept": "*/*",
        "Content-Type": "application/json",
        'Authorization': clientAPIkey,
        }
      let reqOptions = {
      url: `${process.env.REACT_APP_BASE_URL}cpaypayments/getchecksum`,
      method: "POST",
      headers: headersList,
      data: JSON.stringify(data),
          }
          
       axios.request(reqOptions).then(function (response) { 
          var   data2 = {
              "transactionRequest": {
                  "extTransactionId": extId,
                  "clientCode": clientCode,
                  "msisdn": customerNumber,
                  "otp": "",
                  "amount": amountDue,
                  "checksum": response.data,
                  "currency": "maloti",
                  "otpMedium": "sms",
                  "redirectUrl": "",
              }
            };
              let reqOptions = {
              url: `${process.env.REACT_APP_BASE_URL}cpaypayments/payment?cardPayment=true&email=`+customeremail,
              method: "POST",
              headers: headersList,
              data: JSON.stringify(data2)}  
              axios.request(reqOptions).then(function (response) {
              
                setCardPayLoading(false);

                
                var doc = new DOMParser().parseFromString(response.data, "text/xml");
                setIscardPayment(true)
                console.log(response.data);
                document.getElementById('responseDiv').innerHTML = response.data;
                // setResponse(response.data);
                message.success("processing card payment");
                setIsModal2Visible(false);
                
              }).catch((error) => {
                setCardPayLoading(false)
                message.error(error.message)

                openNotificationWithIcon("error", "Error", error.response.data??error.message);
                })   
  
              }).catch((error) => {
                message.error(error.message)
                }) 
    }
    //running the  payment example
    const paymentExample = (values) =>{
      // setLoading(true);
      setCpayPaymentLoading(true);
      // onReset();
      var customerNumber = values.customer;
      var amountDue = values.amount;
      setOTMAmount(amountDue);
      setOTPCusNumber(customerNumber);
      // RunExample(clientCode,customerNumber,amountDue,customeremail,clientAPIkey);
      var extId = "0x" + (new Date().getTime());
      setExtId(extId);
      // first request
      var data = {
          "transactionRequest": {
              "extTransactionId": extId,
              "clientCode": clientCode,
              "msisdn": customerNumber,
              "otp": "",
              "amount": amountDue,
              "checksum": "",
              "currency": "maloti",
              "otpMedium": "sms",
              "redirectUrl": "",
         }
      };
      let headersList = {
        "accept": "*/*",
        "Content-Type": "application/json",
        'Authorization': clientAPIkey,
        }
      let reqOptions = {
      url: `${process.env.REACT_APP_BASE_URL}cpaypayments/getchecksum`,
      method: "POST",
      headers: headersList,
      data: JSON.stringify(data),
          }
          
       axios.request(reqOptions).then(function (response) {
       // second request
       data = {
        "transactionRequest": {
            "extTransactionId": extId,
            "clientCode": clientCode,
            "msisdn": customerNumber,
            "otp": "",
            "amount": amountDue,
            "checksum": response.data,
            "currency": "maloti",
            "otpMedium": "sms",
            "redirectUrl": "",
        }
      };
        let reqOptions = {
        url: `${process.env.REACT_APP_BASE_URL}cpaypayments/payment`,
        method: "POST",
        headers: headersList,
        data: JSON.stringify(data),
            }  
        axios.request(reqOptions).then(function (response) {
        setCpayPaymentLoading(true);
        setIsOTPModalVisible(true)
      }).catch((error) => {
        setCpayPaymentLoading(true);
        handleCancel();
        message.error(error.message)
        })
        }).catch((error) => {
          setCpayPaymentLoading(true);
          handleCancel();
          message.error(error.message);
    
          openNotificationWithIcon("error", "Error", error.response.data??error.message);
        })   
    }



    // sending the recieved otp
    const HandleOTP = (values) =>{
      setOptLoading(true)
      const otp = values.otp;
      SendOPT(OTPCusNumber,clientCode,OTMAmount,otp,clientAPIkey,ExtId); 
      handleCancel();
    }
    const FailedFinish = (error) =>{
     message.error('Please fill the form correctly before submitting');
    }

    function displayRelevent(key) {
      if (key===1) {
      return (
        <div className="site-layout-background" hidden={false}>
          <Row  style={{padding:10}}>
              <Col xs={24} sm={24} md={4} lg={4} xl={4} >
              <Card  style={{boxShadow: "0 20px 27px rgb(0 0 0 / 5%)",borderRadius:10,backgroundColor:'white',
                            margin:10}}>
                  <h5><ApiOutlined /> APIs</h5>
                  <h3 style={{textAlign:'center'}}>45</h3>
              </Card>
              </Col>
              <Col xs={24} sm={24} md={4} lg={4} xl={4}>
              <Card style={{boxShadow: "0 20px 27px rgb(0 0 0 / 5%)",borderRadius:10,margin:10,backgroundColor:'white'}}>
                  <h5><AppstoreOutlined /> Collection</h5>
                  <h3 style={{textAlign:'center'}}>10</h3>
              </Card>
              </Col>
              <Col xs={24} sm={24} md={4} lg={4} xl={4}>
              <Card style={{boxShadow: "0 20px 27px rgb(0 0 0 / 5%)",borderRadius:10,margin:10,backgroundColor:'white'}}>
                  <h5><InteractionOutlined /> Requests</h5>
                  <h3 style={{textAlign:'center'}}>20</h3>
              </Card>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12} >
              <Card style={{boxShadow: "0 20px 27px rgb(0 0 0 / 5%)",borderRadius:10,margin:10,}}>
              <h5 ><ContainerOutlined /> Examples</h5>
              <Space style={{ width: '100%',marginLeft:'17%'}} direction='horizontal'>
                <Button
                  icon={<MobileOutlined />}
                  style={{color:'white',backgroundColor:'#00b33c',borderRadius:5}}
                  onClick={showModal}
                  >
                  Run example
                </Button>

                <Button
                  icon={<CreditCardTwoTone />}
                  style={{color:'white',backgroundColor:'#00b33c',borderRadius:5}}
                  onClick={showModal2}
                >
                  Run Card Payments example
                </Button>
              </Space>
              </Card>
              </Col>
              <Divider/>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}style={{padding:2}}>
                {currentUser?(
              <Card style={{boxShadow: "0 20px 27px rgb(0 0 0 / 5%)",borderRadius:10,margin:10}}>
                  <h5><Avatar size={35} icon={<UserOutlined />}/><br/>{currentUser.ContactPerson}</h5>
                   <Divider/>
                   <Row style={{marginLeft:'10%'}}>
                     <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <p><b><BankOutlined /> Business :</b> <span style={{textAlign:'center'}}>{currentUser.ClientName}</span></p>
                      <p><b># Identifier :</b> <span style={{textAlign:'center'}}>{currentUser.ClientCode}*</span></p>
                      </Col>
                     <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <p><b><MailOutlined /> Email :</b> <span style={{textAlign:'center'}}><Link to={'mailto:'+currentUser.ClientEmail}>{currentUser.ClientEmail}</Link></span></p>
                    <p><b><MobileOutlined /> Merchant Code :</b> <span style={{textAlign:'center'}}>{currentUser.MerchantNumber}</span></p>
                    </Col>
                   </Row>
              </Card>):(navigate('/'))}
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12} style={{padding:2}}>
              <Space direction='horizontal' style={{width:'100%',marginLeft:'10%'}}>
              <Card style={{borderRadius:10,margin:10,height:110,width:200,borderColor:'#00b33c'}} hoverable>
                  <h5><ApiOutlined /><br/> API Parameters</h5>
              </Card>
              <Card style={{borderRadius:10,margin:10,height:110,width:200,backgroundColor:'#00b33c'}} hoverable>
                  <h5 style={{color:'white'}}><FileOutlined /> <br/> KYC Details</h5>
            </Card>
            </Space>
              <Space direction='horizontal' style={{width:'100%',marginLeft:'10%'}}>
              <Card style={{borderRadius:10,margin:10,height:110,width:200,backgroundColor:'#00b33c'}} hoverable>
                  <h5 style={{color:'white'}} ><AppstoreOutlined /> <br/> My Collection</h5>
              </Card>
              <Card style={{borderRadius:10,margin:10,height:110,width:200,borderColor:'#00b33c'}} hoverable>
                  <h5><DatabaseOutlined /> <br/>API Collection</h5>
            </Card>
            </Space>
            </Col>
          </Row>
        </div>
      ) 
      }
    }
  return (
    <Content style={{marginTop:'5%'}}>  
    <Layout hasSider >
      <SiderBar props='1'/>
    <Layout className="site-layout" >
      <Content style={{ margin: '10px 0px 0', overflow: 'initial' }}> 
      {displayRelevent(ActiveKey)}
      </Content>
    </Layout>
  </Layout>
{/* modal for the first example */}
  <Modal title="C-Pay Payment API Example!" visible={isModalVisible} onOk={handleOk} onCancel={handleCancel} footer={null}>
    <img src={cartimg} style={{width:'25%', margin:'5% 35%'}}/>
   <Form onFinish={paymentExample} onFinishFailed={FailedFinish}  ref={formRef} >
    <Form.Item
        name="customer"
        rules={[{required: true,message: 'Please input customer number!',},{
        pattern: /^[0-9]{8,10}$/,
        message: <Alert  style={{margin:5}}message='please a enter a valid Mobile Number' type="error" showIcon />,
        }]}>
        <Input prefix={<MobileOutlined className="site-form-item-icon" />} placeholder="C-Pay Customer Number" />
    </Form.Item>
    <Form.Item
        name="amount"
        rules={[{required: true,message: 'Please input the amount!'},{
        pattern: /^[+-]?([0-9]*[.])?[0-9]+/,
        message: <Alert  style={{margin:5}}message='please a enter a valid amount' type="error" showIcon />,
        }]}>
        <Input prefix={<CreditCardOutlined className="site-form-item-icon" />} placeholder="Amount Due" type='number' step={10} min={1.00} value={10.00} currency='lsl' pattern='0.00' />
    </Form.Item>
    <Form.Item>
      {cpayPaymentLoading?
        <Button  disabled htmlType="submit" style={{color:'white',backgroundColor:'#00b33c',borderRadius:5}}>
          Loading....
        </Button>:
        <Button  htmlType="submit" style={{color:'white',backgroundColor:'#00b33c',borderRadius:5}}>
          Proceed
        </Button>}
      </Form.Item>
   </Form>
  </Modal>
{/* modal for the second exmple */}
  <Modal title="Card Payment API Example!"  visible={isModal2Visible} onOk={handleOk} onCancel={handleCancel} footer={null}>
  <img src={cards} style={{width:'50%', margin:'5% 25%'}}/>
  <Form onFinish={cardPaymentExample} onFinishFailed={FailedFinish} ref={formRef}>
    <Form.Item
        name="customer"
        rules={[{required: true, message: 'Please input customer number!',},{
        pattern: /^[0-9]{8,10}$/,
        message: <Alert  style={{margin:5}} message='Please a enter a valid mobile number' type="error" showIcon />,
      }]}>
        <Input prefix={<MobileOutlined className="site-form-item-icon" />} placeholder="customer number" />
    </Form.Item>
    <Form.Item
        name="amount"
        rules={[{required: true, message: 'Please input amount due!',},{
        pattern: /^[+-]?([0-9]*[.])?[0-9]+/,
        message: <Alert  style={{margin:5}} message='Please a enter a valid amount' type="error" showIcon />,
      }]}>
        <Input prefix={<CreditCardOutlined className="site-form-item-icon" />} placeholder="amount due" />
    </Form.Item>
    <Form.Item
        name="email"
        rules={[{required: true, message: 'Please input customer email!'},{
        pattern: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
        message: <Alert  style={{margin:5}} message='Please a enter a valid email address' type="error" showIcon />,
      }]}>
        <Input prefix={<MailOutlined className="site-form-item-icon" />} placeholder="customer email" />
    </Form.Item>
      <Form.Item>
        
        {CardPayLoading?
        <Button  htmlType="submit" disabled style={{color:'white',backgroundColor:'#00b33c',borderRadius:5}}>
          Loading...
        </Button>:
        <Button  htmlType="submit" style={{color:'white',backgroundColor:'#00b33c',borderRadius:5}}>
          Submit
        </Button>}
    </Form.Item>
   </Form>
  </Modal>
{/* modal for the opt input */}
<Modal title="Please enter the recieved OTP here" visible={isOTPModalVisible} onOk={handleOk} onCancel={handleCancel} footer={null}>
   <Form onFinish={HandleOTP} onFinishFailed={FailedFinish}  ref={formRef} >
    <Form.Item
        name="otp"
        rules={[{required: true, message: <Alert  style={{margin:5}} message='Please input the otp sent to you!' type="error" showIcon />},{
          pattern: /^.{4}$/,
          message: <Alert  style={{margin:5}} message='please a enter a valid OTP' type="error" showIcon />,
      }]}>
        <Input prefix={<MobileOutlined className="site-form-item-icon" />} placeholder="otp" />
    </Form.Item>
    <Form.Item>
      {optLoading?
        <Button  htmlType="submit" disabled style={{color:'white',backgroundColor:'#00b33c',borderRadius:5}}>
          Loading...
        </Button>:
        <Button  htmlType="submit" style={{color:'white',backgroundColor:'#00b33c',borderRadius:5}}>
          Submit
        </Button>}
    </Form.Item>
   </Form>
  </Modal>
  {/* modal to display card payment response */}
  <Modal title="Processing Card Payment" visible={cardPayment} onOk={handleOk}  onCancel={handleCancel} footer={null}>
    <div id='responseDiv'></div>
  </Modal>
  </Content>
);
}

export default Profile